import cookie from 'react-cookie';
import { RECENT_JOBS_COOKIE } from 'constants/constants';

/**
 * Numeric job id for subscription attribution metadata: explicit page id wins,
 * otherwise the most recent id from {@link RECENT_JOBS_COOKIE}.
 * @param {number|string|undefined|null} [explicitJobId] — e.g. `brief.id` from job details
 * @returns {number|null}
 */
export function resolveSubscriptionLogJobId(explicitJobId) {
  if (explicitJobId != null && explicitJobId !== '') {
    const n = Number(explicitJobId);
    if (Number.isFinite(n)) {
      return Math.round(n);
    }
  }
  const recentJobs = cookie.load(RECENT_JOBS_COOKIE) || [];
  const fromCookie = recentJobs[0]?.id;
  if (fromCookie != null && fromCookie !== '') {
    const n = Number(fromCookie);
    if (Number.isFinite(n)) {
      return Math.round(n);
    }
  }
  return null;
}
